// Build-time metadata baked into the JS bundle.
//
// This is deliberately NOT runtime config (see appConfig.ts and ADR 0001): the
// version describes the artifact itself, so it is frozen at build time rather
// than injected per-environment by config.<env>.js. `__APP_VERSION__` is replaced
// literally by Vite's `define` from the VERSION build-arg (ADR 0004 §5 step 7);
// it defaults to the loud `0.0.0-UNSET` sentinel, which flags a build that forgot
// to inject VERSION (and never crashes — it's valid semver).
export const buildMeta = {
  version: __APP_VERSION__,
} as const

export type BuildMeta = typeof buildMeta
